import ReturnForm from "@/components/ReturnForm";

export default function PurchaseReturn() {
  return <ReturnForm mode="purchase" />;
}
